import React from "react";
import { LegalTab } from "./LegalModal";

interface LegalFooterProps {
  onOpenTab: (tab: LegalTab) => void;
  className?: string;
}

export function LegalFooter({ onOpenTab, className = "" }: LegalFooterProps) {
  return (
    <footer className={`py-4 px-6 border-t border-slate-150 bg-slate-50 text-[11px] text-slate-500 ${className}`}>
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        
        {/* Branding & Tagline */}
        <div className="flex flex-col text-center md:text-left gap-0.5">
          <div className="font-bold text-slate-800 flex items-center gap-1.5 justify-center md:justify-start">
            <span>BizNearYou</span>
            <span className="text-[9px] font-normal tracking-wide px-1.5 py-0.2 bg-slate-200 text-slate-600 rounded">
              &copy; {new Date().getFullYear()}
            </span>
          </div>
          <p className="text-slate-400 text-[10px]">Hyper-local business intelligence and scouting platform</p>
        </div>

        {/* Links Grid */}
        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-slate-500 font-medium">
          <button
            type="button"
            onClick={() => onOpenTab("terms")}
            className="hover:text-indigo-600 cursor-pointer hover:underline transition"
          >
            Terms of Service
          </button>
          <span className="text-slate-300">•</span>
          <button
            type="button"
            onClick={() => onOpenTab("privacy")}
            className="hover:text-indigo-600 cursor-pointer hover:underline transition"
          >
            Privacy Policy
          </button>
          <span className="text-slate-300">•</span>
          <button
            type="button"
            onClick={() => onOpenTab("acceptable-use")}
            className="hover:text-indigo-600 cursor-pointer hover:underline transition"
          >
            Acceptable Use Policy
          </button>
          <span className="text-slate-300">•</span>
          <button
            type="button"
            onClick={() => onOpenTab("contact-removal")}
            className="hover:text-indigo-600 cursor-pointer hover:underline font-semibold text-rose-800 transition"
          >
            Contact &amp; Data Removal
          </button>
          <span className="text-slate-300">•</span>
          <button
            type="button"
            onClick={() => onOpenTab("ai-ranking")}
            className="hover:text-indigo-600 cursor-pointer hover:underline transition"
          >
            AI Ranking &amp; Signal Transparency
          </button>
          <span className="text-slate-300">•</span>
          <button
            type="button"
            onClick={() => onOpenTab("safety")}
            className="hover:text-indigo-600 cursor-pointer hover:underline font-bold text-rose-700 transition"
          >
            Trust &amp; Safety Guidelines
          </button>
          <span className="text-slate-300">•</span>
          <button
            type="button"
            onClick={() => onOpenTab("refunds")}
            className="hover:text-indigo-600 cursor-pointer hover:underline transition"
          >
            Refund &amp; Cancellation Policy
          </button>
        </div>
      </div>
    </footer>
  );
}
